const NS = 'MarketEmiTableBlock';
const CLS = 'marketEmiTableBlock';

import { TableBlock } from '../../tableBlock/js/tableBlock';

export class MarketEmiTableBlock extends TableBlock {
	constructor(element) {
		super(element, CLS);

		this.api = this.$element.attr('data-api');

		this.getTableDataFromApi();
	}

	setTableData() {
		this.columnDefs = [
			{
				headerName: 'Currency Type',
				field: 'currencyType',
				cellStyle: {
					'font-weight': 500,
					'padding': 0
				},
				width: 60,
				maxWidth: 60,
				lockPosition: true
			},
			{
				headerName: 'Weight',
				field: 'weight',
				valueFormatter: (params) => {
					let formattedValue;
					let data = params.data;
					let value = params.value;
					let currencyType = data.currencyType.toUpperCase();

					// only for USD and AUD, return 0 decimal points
					if(currencyType === 'AUD' || currencyType === 'USD') {
						formattedValue = Math.trunc(value);
					}
					else {
						formattedValue = _.round(value, 2).toFixed(2);
					}
					// remove commas
					return `${formattedValue} ${data.currencySymbol}Kg`;
				},
				lockPosition: true
			},
			{
				headerName: 'Difference',
				field: 'difference',
				valueFormatter: (params) => {
					let data = params.data;
					let value = params.value;
					let currencyType = data.currencyType.toUpperCase();


					if(!_.isNil(value)) {
						if(value < 0) {
							if(currencyType === 'AUD' || currencyType === 'USD') {
								return `${Math.trunc(value)}${data.currencySymbol}/Kg`;
							}

							return `-${_.round(Math.abs(value), 2).toFixed(2)}${data.currencySymbol}/Kg`;
						}
						else if(value > 0) {
							if(currencyType === 'AUD' || currencyType === 'USD') {
								return `+${Math.trunc(value)}${data.currencySymbol}/Kg`;
							}

							return `+${_.round(value, 2).toFixed(2)}${data.currencySymbol}/Kg`;
						}
					}
					return `- ${data.currencySymbol}/Kg`;
				},
				cellClass: (params) => {
					let value = params.value;

					if(!_.isNil(value)) {
						if(value < 0) {
							return `text-red`;
						}
						else if(value > 0) {
							return `text-green`;
						}
					}
					return '';
				},
				lockPosition: true
			},
			{
				headerName: 'Percentage',
				field: 'percentage',
				valueFormatter: (params) => {
					let value = params.value;

					if(!_.isNil(value)) {
						if(value < 0) {
							return `-${this.numberFormatter.formatNumbersWithCommas(_.round(Math.abs(value), 2).toFixed(2))}%`;
						}
						else if(value > 0) {
							return `+${this.numberFormatter.formatNumbersWithCommas(_.round(value, 2).toFixed(2))}%`;
						}
					}
					return `- %`;
				},
				cellClass: (params) => {
					let value = params.value;

					if(!_.isNil(value)) {
						if(value < 0) {
							return `text-red`;
						}
						else if(value > 0) {
							return `text-green`;
						}
					}
					return '';
				},
				lockPosition: true
			}
		];
	}

	setGridOptions() {
		super.setGridOptions({
			headerHeight: 0
		});
	}

	getTableDataFromApi() {
		let url = this.api;

		if(!_.isEmpty(this.urlParams)) {
			url += `?${$.param(this.urlParams)}`;
		}

		if(this.api) {
			$.ajax({
				type: 'GET',
				url: url,
				dataType: 'json',
				success: (response) => {
					if(response && response.length > 0) {
						this.$element.trigger(`${CLS}.update`, {
							data: response
						});
					}
					else {
						this.$element.trigger(`${CLS}.update`, {
							data: null,
							isEmpty: true
						});
					}
				},
				error: () => {
					this.$element.trigger(`${CLS}.update`, {
						data: null
					});
				}
			});
		}
		else {
			console.error(`${NS}::Error`, 'API is not set.');
			this.$element.trigger(`${CLS}.update`, {
				data: null
			});
		}
	}
}
